{
  "name": "dashboard",
  "version": "2.15.1",
  "scripts": {
    "start": "ng serve --port=5000",
    "release": "semantic-release --no-ci",
    "deploy:dev": "ng build --base-href / --configuration development",
    "deploy:staging": "ng build --base-href / --configuration staging",
    "deploy:prod": "ng build --base-href /",
    "changelog": "conventional-changelog -p angular -i CHANGELOG.md -s"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.0.6",
    "@angular/cdk": "^19.1.0",
    "@angular/common": "^19.0.6",
    "@angular/compiler": "^19.0.6",
    "@angular/core": "^19.0.6",
    "@angular/forms": "^19.0.6",
    "@angular/platform-browser": "^19.0.6",
    "@angular/platform-browser-dynamic": "^19.0.6",
    "@angular/router": "^19.0.6",
    "@auth0/angular-jwt": "^5.2.0",
    "@ng-bootstrap/ng-bootstrap": "^18.0.0",
    "@popperjs/core": "^2.11.8",
    "@primeng/themes": "^19.0.5",
    "@tinymce/tinymce-angular": "^8.0.0",
    "bootstrap": "^5.3.3",
    "bootstrap-icons": "^1.11.3",
    "exceljs": "^4.4.0",
    "file-saver": "^2.0.5",
    "marked": "^17.0.1",
    "primeicons": "^7.0.0",
    "primeng": "^19.0.5",
    "rxjs": "~7.8.0",
    "sweetalert2": "^11.12.4",
    "tinymce": "^7.2.1",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.0.7",
    "@angular/cli": "^19.0.7",
    "@angular/compiler-cli": "^19.0.6",
    "@angular/localize": "^19.0.6",
    "@semantic-release/changelog": "^6.0.3",
    "@semantic-release/commit-analyzer": "^13.0.1",
    "@semantic-release/exec": "^7.1.0",
    "@semantic-release/git": "^10.0.1",
    "@semantic-release/npm": "^12.0.2",
    "@semantic-release/release-notes-generator": "^14.1.0",
    "@types/file-saver": "^2.0.7",
    "@types/jasmine": "~5.1.0",
    "conventional-changelog-cli": "^5.0.0",
    "jasmine-core": "~5.1.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "semantic-release": "^24.2.9",
    "typescript": "~5.5.4"
  }
}
